import { apiServiceWrapper } from '../../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../../Utils/Auth/AuthToken';
import { ADMIN_ROLE } from '../../../../constants/apiRoutes';
import {
  getGraphqlCacheResponse,
  setGraphqlCacheResponse,
} from '../../../../Utils/Storage/IndexDB/indexDbWrappers';
/**
 * list Roles.
 * @returns {Promise} - A promise that resolves with the list of Roles or rejects with an error.
 * @param props
 */
export const listRole = async ({
  accessToken,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const response = await apiServiceWrapper({
    url: `${ADMIN_ROLE}/GetRolesAdmin`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  if (response?.isError) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker,
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }
  return {
    Roles: response.Payload,
    TotalCount: response.Payload?.length,
  };
};

/**
 * Create Role.
 * @returns {Promise} - A promise that resolves with the creation of Profile Group or rejects with an error.
 * @param data
 */
export const createRole = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${ADMIN_ROLE}/AddRole`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Update Role.
 * @returns {Promise} - A promise that resolves with the update of Profile Group or rejects with an error.
 * @param data
 */
export const updateRole = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${ADMIN_ROLE}/UpdateRole`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * delete Role.
 * @returns {Promise} - A promise that resolves with the update of Profile Group or rejects with an error.
 * @param data
 */
export const deleteRole = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${ADMIN_ROLE}/DeleteRole?roleId=${data?.RoleId}`,
    method: 'DELETE',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * get Role.
 * @returns {Promise} - A promise that resolves with the Role or rejects with an error.
 * @param data
 */
export const getRole = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${ADMIN_ROLE}/GetRoleById?roleId=${data?.RoleId}`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};

/**
 * get Role Tenant.
 * @returns {Promise} - A promise that resolves with the Role or rejects with an error.
 * @param data
 */
export const getRoleCategories = async ({
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${ADMIN_ROLE}/GetRolesCategories`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};
